import type { HasID } from "../core/has_id"

export default function getID(obj : HasID): number {
  return obj.id
}